import '@vaadin/custom-field';
import '@descope-ui/descope-combo-box';
import './descope-autocomplete-field-internal';

import {
  componentName,
  AutocompleteFieldClass,
} from './AutocompleteFieldClass';

customElements.define(componentName, AutocompleteFieldClass);

export { AutocompleteFieldClass, componentName };
